import { TransportStatus } from "./transport-statuses";

export const transportListColumns = [
    'created',
    'documentNumber',
    'pickupDate',
    'requester',
    'status',
] as const;
export type TransportColumnKey = typeof transportListColumns[number];

export type TransportColumnSortOrder = {
    column: TransportColumnKey;
    order: 'asc' | 'desc' | null;
}[];

export interface TransportFilters {
    documentNumber:string;
    status: TransportStatus;
    contractorCompanyName: string;
}

export interface TransportRequestParams {
    userId: number;
    appVersion: string;
    sort: TransportColumnSortOrder;
    filters: TransportFilters;
    offset: number;
    limit: number;
};